import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authLogin, authMe, authLogout } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (username, phone) => {
    const data = await authLogin(username, phone);
    if (data?.token) localStorage.setItem("uyap_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await authLogout(); } catch {}
    localStorage.removeItem("uyap_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
